// extracted by css-extract-rspack-plugin
export default {"root":"root-jMqjE_","footer":"footer-qRrq_l"};